/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


export const styles:any[] = ['.navegacao[_ngcontent-%COMP%] {\n  display: block !important; }'];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiQzovVXNlcnMvTWFyY2Vsb01hcnRpbnNGZXJyZWkvRGVza3RvcC9VbmlvMi9VbmlvQ21zL1VuaW9DbXMvQXBwL3NyYy9hcHAvYXBwLmNvbXBvbmVudC5zY3NzLnNoaW0ubmdzdHlsZS50cyIsInZlcnNpb24iOjMsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIm5nOi8vL0M6L1VzZXJzL01hcmNlbG9NYXJ0aW5zRmVycmVpL0Rlc2t0b3AvVW5pbzIvVW5pb0Ntcy9VbmlvQ21zL0FwcC9zcmMvYXBwL2FwcC5jb21wb25lbnQuc2NzcyJdLCJzb3VyY2VzQ29udGVudCI6WyIgIl0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7In0=



// WEBPACK FOOTER //
// ./src/$$_gendir/app/app.component.scss.shim.ngstyle.ts